import { hotRanking } from '@/mocks/siteData';
import { Link } from 'react-router-dom';

const categoryBadge: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
  anime: '动漫',
};

export default function HotRankingSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
          <div className="lg:w-1/2">
            <div className="mb-6">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                热门排行榜
              </h2>
              <p className="mt-1.5 text-sm text-foreground-600">实时热度，大家都在看</p>
            </div>

            <div className="space-y-1">
              {hotRanking.slice(0, 10).map((item) => (
                <Link
                  key={item.rank}
                  to={`/article/${item.rank}`}
                  className="flex items-center gap-4 px-4 py-3 rounded-lg hover:bg-background-50 transition-colors cursor-pointer group"
                >
                  <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                      {item.title}
                    </p>
                  </div>
                  <span className="inline-block px-2 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {categoryBadge[item.category] || item.category}
                  </span>
                  <div className="flex items-center gap-1 text-xs">
                    <span className={`${
                      item.trend === 'up' ? 'text-primary-500' : 'text-secondary-500'
                    }`}>
                      {item.trend === 'up' ? '↑' : '↓'}
                    </span>
                    <span className="text-foreground-600 font-medium">{item.hot}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="mb-6">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                平台数据
              </h2>
              <p className="mt-1.5 text-sm text-foreground-600">千万用户的共同选择</p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-lg bg-background-50 p-5 md:p-6 text-center">
                <div className="text-3xl md:text-4xl font-bold font-heading text-accent-500">5000万+</div>
                <p className="mt-2 text-sm text-foreground-600">注册用户</p>
              </div>
              <div className="rounded-lg bg-background-50 p-5 md:p-6 text-center">
                <div className="text-3xl md:text-4xl font-bold font-heading text-accent-500">10万+</div>
                <p className="mt-2 text-sm text-foreground-600">影视资源</p>
              </div>
              <div className="rounded-lg bg-background-50 p-5 md:p-6 text-center">
                <div className="text-3xl md:text-4xl font-bold font-heading text-accent-500">99.9%</div>
                <p className="mt-2 text-sm text-foreground-600">播放成功率</p>
              </div>
              <div className="rounded-lg bg-background-50 p-5 md:p-6 text-center">
                <div className="text-3xl md:text-4xl font-bold font-heading text-accent-500">4K</div>
                <p className="mt-2 text-sm text-foreground-600">超高清画质</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}